import { Field } from "./Field";
import { Chips } from "./Chips";
import { NICHES, PLATFORMS, GOALS } from "./questions";

export const LevelBody = ({ step, form, set, onEnter }) => {
  const enter = (e) => e.key === "Enter" && onEnter();
  if (step === 0) return (
    <div className="space-y-8">
      <Field label="Your name" testId="input-name" placeholder="e.g. Riya" value={form.name} onChange={(e) => set("name")(e.target.value)} onKeyDown={enter} />
      <Field label="Phone / WhatsApp" testId="input-phone" placeholder="+91 98765 43210" type="tel" value={form.phone} onChange={(e) => set("phone")(e.target.value)} onKeyDown={enter} />
    </div>
  );
  if (step === 1) return (
    <div className="space-y-8">
      <Field label="Business name" testId="input-business-name" placeholder="e.g. Velvet Whisk" value={form.business_name} onChange={(e) => set("business_name")(e.target.value)} onKeyDown={enter} autoFocus />
      <Chips options={NICHES} value={form.niche} onChange={set("niche")} testPrefix="niche-chip" />
      <Field label="Or type your niche" testId="input-niche" placeholder="e.g. Home baker in Bandra" value={form.niche} onChange={(e) => set("niche")(e.target.value)} onKeyDown={enter} />
    </div>
  );
  if (step === 2) return (
    <div className="space-y-6">
      <Field label="Competitor name or @handle" testId="input-competitor" placeholder="e.g. @theirbrand, Brand X" value={form.competitor} onChange={(e) => set("competitor")(e.target.value)} onKeyDown={enter} autoFocus />
      <p className="font-hand text-xl text-[var(--muted)]">psst... we'll show you how to stand out from them</p>
    </div>
  );
  return (
    <div className="space-y-8">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[var(--muted)] mb-3">Main platform</p>
        <Chips options={PLATFORMS} value={form.platform} onChange={set("platform")} testPrefix="platform-chip" />
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[var(--muted)] mb-3">Your #1 goal</p>
        <Chips options={GOALS} value={form.goal} onChange={set("goal")} testPrefix="goal-chip" />
      </div>
    </div>
  );
};
